import { Pipe, PipeTransform } from '@angular/core';
import { InternalLinkService } from '@bling-fe/shared/services';

@Pipe({
  name: 'internalLinks'
})
export class InternalLinksPipe implements PipeTransform {
  constructor(private internalLinkService: InternalLinkService) {}

  transform(html: string | null | undefined): string {
    return this.internalLinkService.normalizeLinks(html);
  }
}
